const path = '$reserve';

export const EVENT_RESOURCE_BOOKMARKUPDATED = `${path}/resource/event/eventBookmarkUpdated`;
export const EVENT_RESOURCE_EVENTLOAD = `${path}/resource/event/eventLoad`;